<template>
  <v-row>
    <v-col>
      <v-card>
        <v-expansion-panels multiple>
          <v-expansion-panel v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="info">
                <v-icon>
                  info
                </v-icon>
                {{ $t('Общая информация') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-3">
                <text-view
                    :display="organization.organizationShortName"
                    multiline
                    md="6"
                    :label="$t('Короткое наименование')" />
                <text-view
                    :display="organization.organizationFullName"
                    multiline
                    md="6"
                    :label="$t('Полное наименование')" />
                <text-view
                    :display="$t(PARTICIPANT_TYPE_ENUM[organization.participantType])"
                    multiline
                    md="6"
                    :label="$t('Категория участия')" />
                <date-view
                    multiline
                    md="6"
                    :display="organization.registrationDate"
                    :label="$t('Дата государственной регистрации юридического лица')" />
                <text-view
                    v-if="!isLoading"
                    multiline
                    md="6"
                    :display="organization.country"
                    :label="$t('Страна')" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="manager">
                <v-icon>
                  person
                </v-icon>
                {{ $t('Единоличный исполнительный орган') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-3">
                <text-view
                    :display="organization.managerFIO"
                    multiline
                    md="6"
                    :label="$t('Руководитель (ФИО)')" />
                <text-view
                    :display="organization.managerPosition"
                    multiline
                    md="6"
                    :label="$t('Должность руководителя')" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="business">
                <v-icon>
                  business
                </v-icon>
                {{ $t('Реквизиты') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-3">
                <text-view
                    :display="organization.inn"
                    multiline
                    md="6"
                    :label="$t('ИНН')" />
                <text-view
                    :display="organization.ogrn"
                    multiline
                    md="6"
                    :label="$t('ОГРН/КИО')" />
                <text-view
                    v-if="showKpp"
                    :display="organization.kpp"
                    multiline
                    md="6"
                    :label="$t('КПП')" />
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-test="{ panel: '' }">
            <v-expansion-panel-header>
              <div id="contact_mail">
                <v-icon>
                  contact_mail
                </v-icon>
                {{ $t('Контактная информация') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-row class="text-left pl-3">
                <!-- <text-view
                      :display="organization.postAddress"
                      multiline
                      md="6"
                      :label="$t('Почтовый адрес')" />
                  <text-view
                      :display="organization.realAddress"
                      multiline
                      md="6"
                      :label="$t('Фактический адрес')" /> -->
                <text-view
                    :display="organization.location"
                    multiline
                    md="6"
                    :label="$t('Место нахождения')" />
                <text-view
                    :display="organization.phone"
                    multiline
                    md="6"
                    :label="$t('Контактный телефон')" />
                <text-view
                    multiline
                    md="6"
                    :display="organization.contactPerson"
                    :label="$t('Контактное лицо')" />
                <text-view
                    multiline
                    md="6"
                    :display="organization.contactPersonPosition"
                    :label="$t('Должность контактного лица')" />
                <text-array-view
                    md="6"
                    :display="organization.email"
                    :label="$t('Адрес электронной почты')" />

              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <slot name="additional" />
        </v-expansion-panels>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

  import TextView from '@/components/reused/ui/TextView.vue'
  import TextArrayView from '@/components/reused/ui/TextArrayView.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import {
    PARTICIPANT_TYPE_ENUM
  } from '@/constants/enums'
  import { DICTIONARY_TYPES, RUSSIAN_COUNTRY_ID } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { DICTIONARIES } from '@/constants/store.js'

  export default {
    components: {
      TextView,
      TextArrayView,
      DateView
    },
    props: {
      organizationInfo: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        DICTIONARY_TYPES,
        PARTICIPANT_TYPE_ENUM,
        isLoading: false
      }
    },
    computed: {
      ...mapState(DICTIONARIES.NAMESPACE, {
        countries: state => (state[DICTIONARIES.STATE.COUNTRIES] || [])
      }),
      organization () {
        const org = this.organizationInfo

        return {
          ...org,
          email: org.email
            ? org.email.split(';').filter(str => !!str.trim().length)
            : [],
          country: this.countries.find(o => o.key === org.country?.toString())?.value || ''
        }
      },
      showKpp () {
        return this.organizationInfo.country === RUSSIAN_COUNTRY_ID
      }
    },
    created () {
      if (!this.countries.length) {
        this.getDictionaryItems()
      }
    },
    methods: {
      ...mapActions(DICTIONARIES.NAMESPACE, {
        getIdentityDictionaryItemsAction: DICTIONARIES.ACTIONS.GET_IDENTITY_DICTIONARY_ITEMS
      }),
      getDictionaryItems: async function () {
        try {
          this.isLoading = true
          await this.getIdentityDictionaryItemsAction({
            dictionaryType: DICTIONARY_TYPES.COUNTRIES
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
